<template>
  <div>
    <el-row class="grid-table">
      <el-form :inline="true" :model='search_data'>
        <el-form-item label="帐号">
          <el-input v-model="search_data.username"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="search_data.userType">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(value,key) in user_type" :key="key"
                       :label="value" :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="search" type="primary" @click="onSearch">查询</el-button>
          <el-button icon="plus" @click="addUser()" :disabled="grade.userAdd">添加用户
          </el-button>
        </el-form-item>
      </el-form>
      <el-table stripe border style="width:100%;margin-top:10px" :data="table_data.data">
        <el-table-column label="昵称" prop="nickname"></el-table-column>
        <el-table-column label="账号" prop="username"></el-table-column>
        <el-table-column label="头像">
          <template slot-scope="scope">
            <div v-if="scope.row.avatar" class="avatar"><img :src="scope.row.avatar.url"/></div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobilePhoneNumber"></el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope">
            {{getUserType(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="当前总分" prop="totalScores"></el-table-column>
        <el-table-column label="高分次数" prop="highScoreCount"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="addUser(scope.row.objectId)" :disabled="grade.userUpdate">编辑
          </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-size="search_data.pageSize"
        layout="total, prev, pager, next,jumper"
        :total="table_data.total">
      </el-pagination>
    </el-row>
  </div>
</template>
<script type="text/javascript">
import utils from '@/utils/index'
import common from '@/../server/common'

export default {
  name: 'list',
  data() {
    return {
      user_type: common.user_type,
      page_grade: common.page_grade,
      grade: {
        userAdd: !0,
        userUpdate: !0
      },
      search_data: {
        username: '',
        userType: '',
        pageSize: 10,
        page: 1
      },
      multipleSelection: [],
      table_data: {
        total: 0,
        data: []
      }
    }
  },
  methods: {
    getUserType (row) {
      return common.user_type[row.userType] || '未知'
    },
    addUser(id){
      this.$router.push({path:"/user/add",query:{id}});
    },
    ajaxData() {
      utils.ajax.call(this, '/userList', this.search_data, (obj, err) => {
        if (!err) {
          this.table_data.data = obj.userList
          this.table_data.total = obj.total
          this.search_data.page = obj.page
        }
      })
    },
    onSearch() {
      this.search_data.page = 1
      this.ajaxData()
    },
    handleCurrentChange(page) {
      if (page !== this.search_data.page) {
        this.search_data.page = page
        this.ajaxData()
      }
    },
  },
  mounted() {
    utils.storage.get('userInfo', obj => {
      this.userType = obj.userInfo.user_type
    })
    this.ajaxData()
  },
  mixins: [common.mixin]
}
</script>
<style lang="less">
  .grid-table {
    .el-form-item {
      display: inline-block;
      max-height: 240px;
      width: ~'calc(24% - 10px)';
      &:first-child {
        .el-input {
          margin-right: 25px;
        }
      }
      &:last-child {
        overflow: hidden;
        white-space: nowrap;
        vertical-align: bottom;
      }
    }
    .el-pagination {
      margin-top: 5px;
      text-align: right;
    }
  }
  .avatar{
    width: 50px;
    height:50px;
    border-radius: 50%;
    display: inline-block;
    overflow: hidden;
    img{
      width: 50px;
      height:50px;
    }
  }
</style>
